export const CommonRoutes = {
  root: {
    relative: "/",
    absolute: "/",
  },
  garageList: {
    relative: "werkstaetten",
    absolute: "/werkstaetten",
  },
  garageProfile: {
    relative: "werkstatt",
    absolute: "/werkstatt",
  },
  checkout: {
    relative: "buchen",
    absolute: "/werkstatt/buchen",
  },
  success: {
    relative: "erfolgreich",
    absolute: "/werkstatt/buchen/erfolgreich",
  },
};
